import React from 'react'
import {
  SimpleForm,
  Create,
  Edit,
  List,
  Datagrid,
  TextField,
  EditButton,
  Filter,
  TextInput,
  NumberInput,
  DateField,
  required,
  BooleanInput,
  BooleanField
} from 'react-admin'
import { Field } from 'react-final-form'
import DateFilters from '../../elements/DateFilters'
import RichTextInput from 'ra-input-rich-text'
import useCloudinary from '../../hooks/useCloudinary'
import ImageInput from '../../elements/ImageInput'

export const Filters = (props) => (
  <Filter {...props}>
    {DateFilters}
  </Filter>
)

export const NewsCreate = (props) => {
  const { widget, source } = useCloudinary()

  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput
          source='title'
          validate={required()}
        />
        <RichTextInput
          source='description'
          validate={required()}
        />
        <Field name='image'>
          {formProps =>
            <ImageInput
              formProps={formProps}
              widget={widget}
              source={source}
            />
          }
        </Field>
        <NumberInput
          source='order'
          validate={required()}
        />
        <BooleanInput
          source='active'
          defaultValue={true}
        />
      </SimpleForm>
    </Create>
  )
}

export const NewsEdit = (props) => {
  const { widget, source } = useCloudinary()

  return (
    <Edit {...props}>
      <SimpleForm>
        <TextField
          source='_id'
          label='Id'
        />
        <TextInput
          source='title'
          validate={required()}
        />
        <RichTextInput
          source='description'
          validate={required()}
        />
        <Field name='image'>
          {formProps =>
            <ImageInput
              formProps={formProps}
              widget={widget}
              source={source}
            />
          }
        </Field>
        <NumberInput
          source='order'
          validate={required()}
        />
        <BooleanInput
          source='active'
        />
        <DateField
          source='createdAt'
          label='Created at'
          showTime
        />
        <DateField
          source='updatedAt'
          label='Updated at'
          showTime
        />
      </SimpleForm>
    </Edit>
  )
}

export const NewsList = (props) => (
  <List
    {...props}
    filters={<Filters />}
  >
    <Datagrid>
      <TextField
        source='title'
      />
      <TextField
        source='order'
      />
      <BooleanField
        source='active'
      />
      <DateField
        source='createdAt'
        label='Created at'
        showTime
      />
      <EditButton />
    </Datagrid>
  </List>
) 